import { queryClient } from './queryClient';

function queryKeyMatchesTournament(queryKey: readonly unknown[], tournamentId: string): boolean {
  const parts = queryKey.map(String);
  const joined = parts.join(' ');

  if (parts[0] === '/api/tournaments' && parts[1] === tournamentId) {
    return true;
  }

  return (
    joined.includes(`/tournaments/${tournamentId}/`) ||
    joined.includes(`/tournaments/${tournamentId}`)
  );
}

/** Invalidate game/tournament queries for one tournament (or all if tournamentId omitted). */
export function invalidateTournamentLiveQueries(tournamentId?: string): void {
  queryClient.invalidateQueries({
    predicate: query => {
      const parts = query.queryKey.map(String);
      const key = parts.join(' ');
      if (tournamentId) {
        if (queryKeyMatchesTournament(query.queryKey, tournamentId)) {
          return true;
        }
        return key.includes('playoff') && key.includes(tournamentId);
      }
      return key.includes('/games') || key.includes('/tournaments');
    },
  });
}
